import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Drawer } from 'antd';

import { viewerMode, mobileView, isArabic } from '../global';
import logo_mobile from '../images/Logo_mobile.svg';
import menu from '../images/menu.svg'
import menuDark from '../images/menu_dark.svg'

import "../styles/global.css";
import "./styles.css"

const Header = ({darkText, root}) => {
    
    const [visible, setVisible] = useState(false);

    const homeStr = isArabic ? 'الرئيسية':'Home';
    const whoWeAreStr = isArabic ? 'من نحن':'Who we are';
    const howItWorksStr = isArabic ? 'كيف يعمل؟':'How it works';
    const joinUsStr = isArabic ? 'انضم إلينا':'Join us';
    const contactUsStr = isArabic ? 'تواصل معنا':'Contact us';

    const logoSize = 80 + (viewerMode*25);
  

  if (mobileView)
    return (
      <div className="content">
        <section className="Row MainSpaceBetween CrossStart">
        <Link to={isArabic?'/ar':'/en'}><img src={logo_mobile} width={logoSize}/></Link>
          <img src={darkText?menuDark:menu} width={logoSize/7} onClick={() => {setVisible(true);}} />
          <Drawer style={{direction:'rtl'}} objectFit='contain' closable={true} title="" placement="top" open={visible} width={200} onClose={() => {setVisible(false)}} >
            <p><Link to="/">{homeStr}</Link></p>
            <p><Link to={isArabic?'/ar#whoweare':'/en#whoweare'} onClick={() =>{setVisible(false);}} >{whoWeAreStr}</Link></p>
            <p><Link to={isArabic?'/ar#howitworks':'/en#howitworks'} onClick={() =>{setVisible(false);}} >{howItWorksStr}</Link></p>
            <p><Link to={isArabic?'/ar#joinus':'/en#howitworks'} onClick={() =>{setVisible(false);}} >{joinUsStr}</Link></p>
            <p><Link to={isArabic?'/ar#contactus':'/en#contactus'} onClick={() =>{setVisible(false);}} >{contactUsStr}</Link></p>
            <p>
              <Link to={(isArabic?"/ar/":"/en/")+root} onClick={() =>{setVisible(false);}}>{isArabic?'العربية':'English'}</Link>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <Link to={(isArabic?"/en/":"/ar/")+root} onClick={() =>{setVisible(false);}}>{isArabic?'English':'العربية'}</Link>
            </p>
          </Drawer>
        </section>
      </div>
    )
  else
    return (
      <div className="content">
      <section className="Row MainSpaceBetween CrossStart">
        <Link to={isArabic?'/ar':'/en'}><img src={logo_mobile} width={logoSize}/></Link>
      <div>
        <li className='Inline'><Link className='Orange' to={isArabic?'/ar':'/en'}>{homeStr}</Link></li>
        {/* <li><a onClick={() => document.getElementById('whoweare')?.scrollIntoView()} >{whoWeAreStr}</a></li> */}
        <li className='Inline'><Link className={darkText?'Black':'White'} to={isArabic?'/ar#whoweare':'/en#whoweare'}>{whoWeAreStr}</Link></li>
        <li className='Inline'><Link className={darkText?'Black':'White'} to={isArabic?'/ar#howitworks':'/en#howitworks'}>{howItWorksStr}</Link></li>
        <li className='Inline'><Link className={darkText?'Black':'White'} to={isArabic?'/ar#joinus':'/en#howitworks'}>{joinUsStr}</Link></li>
        <li className='Inline'><Link className={darkText?'Black':'White'} to={isArabic?'/ar#contactus':'/en#contactus'}>{contactUsStr}</Link></li>
        <li className='Inline'></li>
        <li className='Inline'></li>
        <li className='Inline'>
            <Link className={(darkText?'Black ':'White ')+'Black Trans'} to={(isArabic?"/ar/":"/en/")+root}>{isArabic?'العربية':'English'}</Link>
            <div className={darkText?'Inline Black':'Inline White'}>|</div>
            <Link className={(darkText?'Black ':'White ')} to={(isArabic?"/en/":"/ar/")+root}>{isArabic?'English':'العربية'}</Link>
        </li>
      </div>
    </section>
    </div>
  )
}

export default Header
